import axiosPrivateInstance from 'middlewares/AxiosInstance'

const getActive = () => axiosPrivateInstance.get('/active-harvests')

export default { getActive }
